module.exports = __webpack_public_path__ + "static/media/public_status.3a064e52.svg";